import React, { useEffect, useState } from "react";
import { ThemeProvider } from "styled-components";
import { darkTheme, lightTheme } from "./frontend/styles/theme";
import { GlobalStyle } from "./frontend/styles/globalStyles";
import { Helmet } from "react-helmet"
import Layout from "./frontend/components/Layout/Layout";
import Routes from "./Routes";
import Login from "./frontend/pages/Login";

import menuDefault from './lib/json/menu.json'
import empresasData from "./lib/json/empresas.json"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Import Bootstrap JavaScript
import 'jquery'; // Import jQuery
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import { BootBox } from "./frontend/components/BootBox";
import { decryptAES, ErroMsg, retornaPerfil } from "./frontend/contents/VariaveisGlobais";
import axios from "axios";
import MapaComparativo from "./frontend/pages/Compras/MapaCotacao";
import HomologacaoFornecedor from "./frontend/pages/Compras/Fornecedores/HomologacaoFornecedor";
import { ConsultaAPI_URL } from "./backend/ConsultaAPI";
import { ConsumoAPI_POST } from "./backend/ConsumoAPI";
import { logoutSessao, verificarSessaoAtiva } from "./utils/sessao";


export const ThemeContext = React.createContext(null);

const App = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const navigate = useNavigate();
    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    
    const [isHomologacao, setIsHomologacao] = useState(false);
    const [isCotacao, setIsCotacao] = useState(false);
    const [cotacao, setCotacao] = useState();
    
    const [theme, setTheme] = useState("dark");
    const themeStyle = theme === 'light' ? lightTheme : darkTheme;

	const [microsoftInstance, setMicrosoftInstance] = useState();
	const [microsoftAcount, setMicrosoftAcount] = useState();
    
    var usuarioLogado

    window.ErroMsgGlobal = ErroMsg;

    // useEffect(() => {

    //     appInit()

    //     // const interval = setInterval(async () => {
    //     //     const usuario = localStorage.getItem('username');

    //     //     if (usuario){
    //     //         const ativo = await verificarSessaoAtiva(usuario);
    
    //     //         if (ativo) {
    //     //             setUsername('');
    //     //             setLoggedIn(false);

    //     //             localStorage.clear();

    //     //             navigate('/');
    //     //         }
    //     //     }
    //     // }, 30 * 60 * 1000); // verifica a cada 30 segundos

    //     // return () => clearInterval(interval);
    // }, []);
    useEffect(() => {
        const checkVersion = async () => {
        //     try {
        //         const response = await fetch(`/version.json?ts=${Date.now()}`, {
        //             cache: "no-store"
        //         });
		// 
        //         const data = await response.json();
        //         const CURRENT_VERSION = window._env_?.REACT_APP_VERSION || process.env.REACT_APP_VERSION;
		// 
        //         if (data.version !== CURRENT_VERSION) {
		// 
        //             console.log("Nova versão detectada. Atualizando...");
		// 
        //             if ("caches" in window) {
        //                 const names = await caches.keys();
        //                 await Promise.all(names.map(name => caches.delete(name)));
        //             }
		// 
        //             sessionStorage.clear();
		// 
        //             window.location.href = window.location.origin + "?v=" + Date.now();
        //             return false;
        //         }
		// 
        //         return true;
		// 
        //     } catch (err) {
        //         console.warn("Erro ao verificar versão:", err);
                return true;
        //     }
        };

        const appInit = async() => {
            if (window.location.pathname.includes('/Cotacoes/Fornecedor')){
                const secretKeyCotacao = window._env_?.REACT_APP_KEY_COTACAO
                
                const encryptedText = window.location.pathname.replace('/compras/Cotacoes/Fornecedor/','')
                const dadosCotacao = decryptAES(encryptedText, secretKeyCotacao)
                
                try{ 
                    const dadosCotacaoJSON = JSON.parse(dadosCotacao)
                    setIsCotacao(true)
                    setCotacao(dadosCotacaoJSON)
                }catch {
                    console.log("Falha ao converter os dados da Cotação")
                }
            }else if (window.location.pathname.includes('/Homologacao/Fornecedor')){
                const secretKeyCotacao = window._env_?.REACT_APP_KEY_COTACAO
                
                const encryptedText = window.location.pathname.replace('/compras/Homologacao/Fornecedor/','')
                const dadosCotacao = decryptAES(encryptedText, secretKeyCotacao)
                
                try{ 
                    const dadosCotacaoJSON = JSON.parse(dadosCotacao)
                    setIsHomologacao(true)
                    setCotacao(dadosCotacaoJSON)
                }catch {
                    console.log("Falha ao converter os dados da Cotação")
                }
            }else{
                // Verifica se o usuário está autenticado ao carregar a página
                usuarioLogado = undefined
                const storedUsername = localStorage.getItem('username');
                await handleUsuario();
                            
                if (usuarioLogado) {
                    localStorage.clear();                    
                    handleDadosLogin(usuarioLogado)

                    setUsername(storedUsername);
                    setTheme(JSON.parse(usuarioLogado).tema);
                    setLoggedIn(true);
                }else{
                    navigate('/');
                    return null;
                }
            }
        }

        const start = async () => {
            const canContinue = await checkVersion();

            if (!canContinue) return;

            await appInit();
        };

        start();

        //const interval = setInterval(checkVersion, 300000);
		//
        //const handleVisibility = () => {
        //    if (!document.hidden) {
        //        checkVersion();
        //    }
        //};
		//
        //document.addEventListener("visibilitychange", handleVisibility);
		//
        //return () => {
        //    clearInterval(interval);
        //    document.removeEventListener("visibilitychange", handleVisibility);
        //};

    }, []);

    const handleUsuario = async()=> {       
        try {
            const usuariosDados = await ConsultaAPI_URL('usuarioSistema/check_token');
            let usuarioLogin = usuariosDados.user;
            
            if (usuarioLogin){
                let menuSistema = JSON.stringify(menuDefault, null, 2)
                if (usuarioLogin.usuario !== 'ADMIN'){
                    let empresaHabilitadas = ''
                    let parametrosEmpresas = ''
			
                    //Verificar Perfil e pegar informação do Perfil
                    const perfilId = JSON.parse(usuarioLogin.perfil).value
                    
                    if (perfilId){
                        const dadosPerfil = await retornaPerfil()
                        const perfil = dadosPerfil.perfil.find( (item) => item.idPerfil === parseInt(perfilId))
                        menuSistema = perfil.menu;
                        empresaHabilitadas = perfil.empresaHabilitadas;
                        parametrosEmpresas = perfil.parametrosEmpresas;
                    }else{
                        menuSistema = usuarioLogin.menu;
                        empresaHabilitadas = usuarioLogin.empresaHabilitadas;
                        parametrosEmpresas = usuarioLogin.parametrosEmpresas;
                    }

                    usuarioLogin.empresaHabilitadas = empresaHabilitadas;
                    usuarioLogin.parametrosEmpresas = parametrosEmpresas;
                }
                
                usuarioLogin.tema = usuarioLogin.tema || 'dark';
                usuarioLogin.menu = menuSistema;
                usuarioLogado = JSON.stringify(usuarioLogin);
            }
        }catch(error){
            ErroMsg('Usuário não Logado ou com Token Expirado!')            
        }

        if (!usuarioLogado){
            setUsername('');
            localStorage.clear();
            
            setLoggedIn(false);
        }
	}

    const handleLogin = (userName, usuarioLogado) => {
        setUsername(userName);
        handleDadosLogin(usuarioLogado);
        
        setLoggedIn(true);
    }
    
    const handleDadosLogin = (usuarioLogado) => {
        const usuario = JSON.parse(usuarioLogado);
        
        setTheme(usuario.tema);
        const empresasFiltradas = empresasData.empresas.filter((empresa) => usuario.empresaHabilitadas.includes(empresa.empresaFilial));
      
        const options = empresasFiltradas.map((empresa) => ({
          value: empresa.empresaFilial,
          text: empresa.empresaFilial + ' - ' + empresa.nomeEmpresa,
        }));

        localStorage.setItem('IsMobile', isMobile);
        localStorage.setItem('username', usuario.usuario);
        localStorage.setItem('usuarioLogado', usuarioLogado);
        localStorage.setItem('empresaFilial', usuario.empresaHabilitadas[0]);
        localStorage.setItem('empresasOptions', JSON.stringify(options,null,2));
    };
    
    const handleLogout = async() => {
        const usuario = localStorage.getItem('username');
        logoutSessao(usuario)

        setUsername('');
        localStorage.clear();
        
        if (microsoftInstance){
            try {
                // Get the user's account
                microsoftInstance.logout({ account: microsoftAcount.account });
			} catch (error) {
                console.error('Silent logout error:', error);
			}
        }
        
        setLoggedIn(false);
        
        navigate('/');
    };

    return (
        <ThemeContext.Provider value={{theme, setTheme}} >
            <ThemeProvider theme={themeStyle}>
                <GlobalStyle />
                <BootBox>
                    <Helmet>
                        <title>Tools System - by NPE</title>
                        <link rel="dns-prefetch preconnect" href="https://fonts.googleapis.com" />
                        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
                        <link href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap" rel="stylesheet"/>                    
                    </Helmet>

                    { loggedIn && localStorage.getItem('username') ? 
                        (
                            <>
                                <Layout onLogout={handleLogout}>
                                    <Routes/>
                                </Layout>
                            </>
                        ) 
                    : !isCotacao && !isHomologacao
                        ? (
                            <>
                                <Login 
                                    onLogin={handleLogin}
                                    setInstance={setMicrosoftInstance}
                                    setAccount={setMicrosoftAcount}
                                />
                            </>
                        ) : isCotacao ? (
                                <>
                                    <MapaComparativo
                                        Cotacao={cotacao}
                                    />
                                </>
                            ) :
                            (
                                <>
                                    <HomologacaoFornecedor
                                        dadosFornecedor={cotacao}
                                    />
                                </>
                            )
                        
                    }
                </BootBox>
            </ThemeProvider>
            <ToastContainer />
        </ThemeContext.Provider>
    );
}

export default App;